import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../common/Button';
import '../../assets/css/common/table.css';
import '../../assets/css/common/common.css';
import ImageModal from '../common/ImageModal';
import { setSort } from '../../redux/actions/common';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors } from '../../redux/actions/error';
import { fetchDepartments } from '../../redux/actions/api';
import { renderRowValue } from '../../utils/helpers/table';
import DiscountLegend from './DiscountLegend';

const EditTable = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        confirmStatus,
        heads,
        body,
        dataTable = [],
        setDataTable,
        isHeightTr,
        onlyTab,
        normal,
        dataText,
        discounts = [],
        isSearched,
        pagination,
        setSelectedData,
    } = props;

    // 申請画面
    const isRequestingPage = confirmStatus === 'REQUESTING';
    // 承認画面
    const isConfirmPage = confirmStatus === 'NOT_CONFIRM';
    // 差戻画面
    const isRemandPage = confirmStatus === 'REMAND';
    // 承認済み画面
    const isConfirmedPage = confirmStatus === 'CONFIRMED';

    // 申請画面、差戻画面のチェックボックスフィールド
    const REQUESTING_CHECKBOX_FIELD = 'selected';
    // 承認画面のチェックボックスフィールド（承認）
    const CONFIRMED_CHECKBOX_FIELD = 'confirmed';
    // 承認画面のチェックボックスフィールド（差戻）
    const REMAND_CHECKBOX_FIELD = 'remand';

    const [isCheckAllFirst, setIsCheckAllFirst] = useState(false);
    const [isCheckAllSecond, setIsCheckAllSecond] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);

    const sort = useSelector((state) => state.sort);

    const storage = useSelector((state) => state.storage);
    const { isHead, isFreshness, isCompetitor, isFlyer } = storage;

    useEffect(() => {
        dispatch(clearErrors());
        dispatch(fetchDepartments());
    }, [dispatch]);

    useEffect(() => {
        checkCheckAll(dataTable);
    }, [pagination]);

    const isSubset = (notColoredItems, items) => {
        const itemIds = new Set(items.map((item) => item.id));
        return notColoredItems?.every((item) => itemIds.has(item.id));
    };

    const checkCheckAll = (dataTable) => {
        const selectedItem = dataTable.filter((item) => item.selected === true);
        const confirmedItem = dataTable.filter((item) => item.confirmed === true);
        const remandItem = dataTable.filter((item) => item.remand === true);

        const notColoredItem = isRequestingPage
            ? dataTable
            : dataTable.filter(
                  (item, index) => discountClass(discounts[index]) === '' || discountClass(discounts[index]) === 'linked-item',
              );
        const deletedItem = dataTable.filter((item) => !item.deleteFlag);
        const isSelected = isSubset(notColoredItem, selectedItem);
        const isConfirmed = isSubset(notColoredItem, confirmedItem);
        const isRemand = isSubset(notColoredItem, remandItem);
        const isDeleted = isSubset(deletedItem, selectedItem);

        if (isConfirmPage) {
            if ((confirmedItem.length === dataTable.length || isConfirmed) && !(notColoredItem.length === 0)) {
                setIsCheckAllFirst(true);
            } else {
                setIsCheckAllFirst(false);
            }
            if ((remandItem.length === dataTable.length || isRemand) && !(notColoredItem.length === 0)) {
                setIsCheckAllSecond(true);
            } else {
                setIsCheckAllSecond(false);
            }
        } else if (isConfirmedPage) {
            if ((selectedItem.length === dataTable.length || isDeleted) && !(deletedItem.length === 0)) {
                setIsCheckAllFirst(true);
            } else {
                setIsCheckAllFirst(false);
            }
        } else {
            if ((selectedItem.length === dataTable.length || isSelected) && !(notColoredItem.length === 0)) {
                setIsCheckAllFirst(true);
            } else {
                setIsCheckAllFirst(false);
            }
        }
    };

    useEffect(() => {
        if (setSelectedData) {
            setSelectedData();
        }
    }, [dataTable]);

    const handleOpenModal = (imageUrl) => {
        if (imageUrl) {
            setImageUrl(imageUrl);
            setShowModal(true);
        }
    };
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const toggleCheckboxAll = (field, setIsCheckAll, value) => {
        const newDataTable = dataTable.map((item, index) => {
            if (isConfirmPage && value) {
                // 承認画面で一括選択の場合は他のチェックボックスを解除する
                if (discountClass(discounts[index]) === '' || discountClass(discounts[index]) === 'linked-item') {
                    return {
                        ...item,
                        [CONFIRMED_CHECKBOX_FIELD]: false,
                        [REMAND_CHECKBOX_FIELD]: false,
                        [field]: value,
                    };
                } else {
                    return {
                        ...item,
                        [CONFIRMED_CHECKBOX_FIELD]: false,
                        [REMAND_CHECKBOX_FIELD]: false,
                    };
                }
            } else if (isConfirmedPage && value) {
                if (item.deleteFlag) {
                    return {
                        ...item,
                        [REQUESTING_CHECKBOX_FIELD]: false,
                    };
                }
            }
            return { ...item, [field]: value };
        });
        setDataTable(newDataTable);
        setIsCheckAllFirst(false);
        setIsCheckAllSecond(false);
        setIsCheckAll(value);
    };

    const toggleCheckbox = (field, id) => {
        const newDataTable = dataTable.map((item) => {
            if (item.id === id) {
                if (isConfirmPage) {
                    return {
                        ...item,
                        [CONFIRMED_CHECKBOX_FIELD]: false,
                        [REMAND_CHECKBOX_FIELD]: false,
                        [field]: !item[field],
                    };
                }
                return { ...item, [field]: !item[field] };
            }
            return item;
        });
        setDataTable(newDataTable);
        checkCheckAll(newDataTable);
    };

    const renderHeads = () => {
        const headLength = heads?.filter((head) => head && !head.disabled).length;
        return (
            <>
                {normal && (
                    <tr>
                        <th className="invisible column" colSpan={heads && headLength > 1 ? headLength - 1 : 1}></th>
                        <th
                            className="checkbox freeze-column freeze-right-0"
                            style={{ padding: '0px', backgroundColor: '#f8fafc', borderRight: 0 }}
                        >
                            <button
                                className={`btn price-request__all ${isCheckAllFirst ? 'btn--secondary' : 'btn--primary'}`}
                                onClick={() =>
                                    isCheckAllFirst
                                        ? toggleCheckboxAll(REQUESTING_CHECKBOX_FIELD, setIsCheckAllFirst, false)
                                        : toggleCheckboxAll(REQUESTING_CHECKBOX_FIELD, setIsCheckAllFirst, true)
                                }
                            >
                                {isCheckAllFirst ? t('button.release_all') : t('button.check_all')}
                            </button>
                        </th>
                    </tr>
                )}
                {onlyTab && (
                    <tr>
                        <th className="invisible column" colSpan={heads && headLength > 1 ? headLength - 1 : 1}></th>
                    </tr>
                )}
                {(isRequestingPage || isRemandPage) && (
                    // 申請画面、差戻画面の場合
                    <tr>
                        <th className="legend" colSpan={heads && headLength > 1 ? headLength - 1 : 1}>
                            <DiscountLegend />
                        </th>
                        <th className="checkbox freeze-column freeze-right-0" style={{ padding: '0px' }}>
                            <button
                                className={`btn price-request__all ${isCheckAllFirst ? 'btn--secondary' : 'btn--primary'}`}
                                onClick={() =>
                                    isCheckAllFirst
                                        ? toggleCheckboxAll(REQUESTING_CHECKBOX_FIELD, setIsCheckAllFirst, false)
                                        : toggleCheckboxAll(REQUESTING_CHECKBOX_FIELD, setIsCheckAllFirst, true)
                                }
                            >
                                {isCheckAllFirst ? t('button.release_all') : t('button.check_all')}
                            </button>
                        </th>
                    </tr>
                )}
                {isConfirmPage && (
                    // 承認画面の場合
                    <tr>
                        {isHead ? (
                            <>
                                <th className="legend" colSpan={heads && headLength > 1 ? headLength - 2 : 1}>
                                    <DiscountLegend />
                                </th>
                                <th className={`checkbox freeze-column freeze-right-53`} style={{ padding: '0px' }}>
                                    <button
                                        className={`btn confirm-registration__all-set ${isCheckAllFirst ? 'btn--secondary' : 'btn--primary'}`}
                                        onClick={() =>
                                            isCheckAllFirst
                                                ? toggleCheckboxAll(CONFIRMED_CHECKBOX_FIELD, setIsCheckAllFirst, false)
                                                : toggleCheckboxAll(CONFIRMED_CHECKBOX_FIELD, setIsCheckAllFirst, true)
                                        }
                                    >
                                        {isCheckAllFirst ? t('button.release_all') : t('button.check_all')}
                                    </button>
                                </th>
                                <th className={`checkbox freeze-column freeze-right-0`} style={{ padding: '0px' }}>
                                    <button
                                        className={`btn confirm-registration__all-remand ${isCheckAllSecond ? 'btn--secondary' : 'btn--primary'}`}
                                        onClick={() =>
                                            isCheckAllSecond
                                                ? toggleCheckboxAll(REMAND_CHECKBOX_FIELD, setIsCheckAllSecond, false)
                                                : toggleCheckboxAll(REMAND_CHECKBOX_FIELD, setIsCheckAllSecond, true)
                                        }
                                    >
                                        {isCheckAllSecond ? t('button.release_all') : t('button.check_all')}
                                    </button>
                                </th>
                            </>
                        ) : (
                            <>
                                <th className="legend" colSpan={heads && headLength > 1 ? headLength - 3 : 1}>
                                    <DiscountLegend />
                                </th>
                                <th className={`checkbox freeze-column freeze-right-133`} style={{ padding: '0px' }}>
                                    <button
                                        className={`btn confirm-registration__all-set ${isCheckAllFirst ? 'btn--secondary' : 'btn--primary'}`}
                                        onClick={() =>
                                            isCheckAllFirst
                                                ? toggleCheckboxAll(CONFIRMED_CHECKBOX_FIELD, setIsCheckAllFirst, false)
                                                : toggleCheckboxAll(CONFIRMED_CHECKBOX_FIELD, setIsCheckAllFirst, true)
                                        }
                                    >
                                        {isCheckAllFirst ? t('button.release_all') : t('button.check_all')}
                                    </button>
                                </th>
                                <th className={`checkbox freeze-column freeze-right-80`} style={{ padding: '0px' }}>
                                    <button
                                        className={`btn confirm-registration__all-remand ${isCheckAllSecond ? 'btn--secondary' : 'btn--primary'}`}
                                        onClick={() =>
                                            isCheckAllSecond
                                                ? toggleCheckboxAll(REMAND_CHECKBOX_FIELD, setIsCheckAllSecond, false)
                                                : toggleCheckboxAll(REMAND_CHECKBOX_FIELD, setIsCheckAllSecond, true)
                                        }
                                    >
                                        {isCheckAllSecond ? t('button.release_all') : t('button.check_all')}
                                    </button>
                                </th>
                                <th className="invisible"></th>
                            </>
                        )}
                    </tr>
                )}
                {isConfirmedPage && (
                    // 承認済み競合店売価一覧画面の場合
                    <tr>
                        {isCompetitor || isFlyer ? (
                            // 競合店売価登録
                            <>
                                <th className="legend" colSpan={heads && headLength > 1 ? headLength - 1 : 1}>
                                    <DiscountLegend />
                                </th>
                                <th
                                    className="checkbox freeze-column freeze-right-0"
                                    style={{ padding: '0px', backgroundColor: '#f8fafc', borderRight: 0 }}
                                >
                                    <button
                                        className={`btn price-request__all ${isCheckAllFirst ? 'btn--secondary' : 'btn--primary'}`}
                                        onClick={() =>
                                            isCheckAllFirst
                                                ? toggleCheckboxAll(REQUESTING_CHECKBOX_FIELD, setIsCheckAllFirst, false)
                                                : toggleCheckboxAll(REQUESTING_CHECKBOX_FIELD, setIsCheckAllFirst, true)
                                        }
                                        disabled={isSearched}
                                    >
                                        {isCheckAllFirst ? t('button.release_all') : t('button.check_all')}
                                    </button>
                                </th>
                            </>
                        ) : (
                            // 鮮度起因値下げ登録 or 本部指示
                            <th className="legend" colSpan={heads && headLength > 1 ? headLength : 1}>
                                <DiscountLegend />
                            </th>
                        )}
                    </tr>
                )}
                <tr>
                    {heads?.map((head, index) => {
                        if (Object.keys(head).length === 0 || head.disabled) {
                            return <></>;
                        }

                        return (
                            <th
                                key={index}
                                colSpan={head.colSpan}
                                className={`v-select-default ${head.field ? 'sort' : ''} ${sort.sortField === head.field && sort.sortType === 'DESC' ? 'active' : ''} ${head.className}`}
                                onClick={() => {
                                    if (!head.field) {
                                        return;
                                    }
                                    const sortType = sort.sortField === head.field ? (sort.sortType === 'ASC' ? 'DESC' : 'ASC') : 'DESC';
                                    dispatch(
                                        setSort({
                                            sortField: head.field,
                                            sortType: sortType,
                                        }),
                                    );
                                }}
                            >
                                {head?.title}
                            </th>
                        );
                    })}
                </tr>
            </>
        );
    };

    const discountClass = (discount) => {
        switch (discount) {
            case '10%':
                return isFreshness ? '' : 'warning';
            case '30%':
                return 'deviate-warning';
            case 'linkedItem':
                return 'linked-item';
            // CMP-1604: 原価割れ判断が不十分なため一時的に削除
            // case 'belowCost':
            //     return 'below-cost';
            default:
                return '';
        }
    };

    const renderRows = () => {
        const headLength = heads?.filter((head) => head && !head.disabled).length;
        return (
            <>
                {dataTable.length > 0 ? (
                    <>
                        {dataTable?.map((itemRow, indexRow) => (
                            <tr key={indexRow} className={`${discountClass(discounts[indexRow])} ${isHeightTr ? 'v-minHeight-46' : ''}`}>
                                {body?.columns
                                    ?.filter((item) => !!item)
                                    .map((itemColumn, indexColumn) => {
                                        if (Object.keys(itemColumn).length === 0 || itemColumn.disabled) {
                                            return <></>;
                                        }
                                        return (
                                            <td
                                                key={indexColumn}
                                                className={`${itemColumn.isButton ? 'components__table-btn_body' : ''} ${
                                                    itemColumn?.isBorder ? 'cell-border' : ''
                                                } ${itemColumn?.className ?? ''}`}
                                            >
                                                {itemColumn.isInput ? (
                                                    itemRow[itemColumn?.field ?? ''] !== undefined && (
                                                        <div className="form-textarea">
                                                            <textarea
                                                                disabled={!isConfirmPage}
                                                                value={itemRow[itemColumn?.field ?? '']}
                                                                className={`form-control ${itemColumn?.className ?? ''}`}
                                                                onInput={(event) => {
                                                                    itemColumn.onChange(itemRow.id, event.target.value);
                                                                }}
                                                                autoComplete="off"
                                                                maxLength={itemColumn?.maxLength}
                                                            />
                                                        </div>
                                                    )
                                                ) : itemColumn.isCheckbox ? (
                                                    <div className={`form-check custom-checkbox`}>
                                                        <input
                                                            type="checkbox"
                                                            id={itemColumn.field + itemRow.id}
                                                            className="form-check-input"
                                                            name={itemColumn.field + itemRow.id}
                                                            checked={
                                                                itemColumn?.reverse ? !itemRow[itemColumn.field] : itemRow[itemColumn.field]
                                                            }
                                                            onChange={() => {
                                                                toggleCheckbox(itemColumn.field, itemRow.id);
                                                            }}
                                                            disabled={
                                                                isConfirmedPage && itemColumn?.field === 'selected'
                                                                    ? itemRow['deleteFlag']
                                                                    : itemColumn?.checkboxDisabled
                                                            }
                                                        />
                                                        <label className="form-check-label" htmlFor={itemColumn.field + itemRow.id}></label>
                                                    </div>
                                                ) : itemColumn.isButtonDelete ? (
                                                    <button
                                                        className="btn btn--icon btn--secondary confirm-delete-modal"
                                                        onClick={() => itemColumn.onClick(indexRow, itemRow)}
                                                    >
                                                        <i className="icon-bin"></i>
                                                        <span className="btn-text"></span>
                                                    </button>
                                                ) : itemColumn.isButtonEdit ? (
                                                    <Button
                                                        className="btn btn--icon btn--primary confirm-delete-modal"
                                                        onClick={() => itemColumn.onClick(indexRow, itemRow)}
                                                    >
                                                        <i className="icon-edit"></i>
                                                        <span className="btn-text"></span>
                                                    </Button>
                                                ) : itemColumn?.isLink && itemRow?.imageUrl ? (
                                                    <span
                                                        className="text-underline"
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            event.preventDefault();
                                                            handleOpenModal(itemRow?.imageUrl);
                                                        }}
                                                    >
                                                        ●
                                                    </span>
                                                ) : itemColumn?.field === 'status' ? (
                                                    <span className="status-multiline">{itemRow.status}</span>
                                                ) : (
                                                    <span>{renderRowValue(t, itemColumn, itemRow)}</span>
                                                )}
                                            </td>
                                        );
                                    })}
                            </tr>
                        ))}
                    </>
                ) : (
                    <>
                        <div class="no-result-overlay">{dataText ?? 'データが存在しません。'}</div>
                        <div className="hover-overlay"></div>
                        <tr className="no-result">
                            {headLength - 1 && <td colSpan={headLength - 1} className="no-result-left"></td>}
                            <td className="no-result-right no-result-freeze-right v-base_minWidth--30"></td>
                        </tr>
                        <tr>
                            <td className="no-result-bottom" colSpan={headLength || 1}></td>
                        </tr>
                    </>
                )}
            </>
        );
    };

    return (
        <div>
            <ImageModal show={showModal} handleClose={handleCloseModal} imageUrl={imageUrl} />
            <div className={`okc-table components__table-wrapper bases__padding--bottom20`}>
                <div className="table-responsive">
                    <table className="w-100">
                        <thead>{renderHeads()}</thead>
                        <tbody className="okc-table__wrapper">{renderRows()}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default EditTable;
